import { render, staticRenderFns } from "./IncidentAlertView.vue?vue&type=template&id=32f4b5d8"
import script from "./IncidentAlertView.vue?vue&type=script&lang=js"
export * from "./IncidentAlertView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports